import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=59ee9cb8"
import script from "./ContractsTable.vue?vue&type=script&lang=ts"
export * from "./ContractsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports